import { Navigate } from 'react-router-dom';

import { useAuth } from '@alamo/auth';

interface CommissionEligibleRouteProps {
  children: React.ReactNode;
  allowedConsultantTypes?: readonly string[];
}

/**
 * Gate da self-view "Minhas comissões" (/commissions): passa quem tem
 * consultant_profile elegível a comissão — `consultantType != null &&
 * commissionEligible !== false` (contrato ESCR-commission-clt-scheme).
 *
 * Diferente do ConsultorOnlyRoute (MLM), quem decide aqui é o
 * `commissionEligible` do /auth/me, NÃO o consultantType: CLT recebe comissão
 * pelo esquema por placa (Phase 35) e DEVE acessar /commissions.
 *
 * Quem não tem consultant_profile (admin, gerente e qualquer perfil
 * administrativo) vai para /dashboard: a superfície admin de comissões é
 * /admin/comissoes/extrato, alcançada pelo menu de administração.
 */
export function CommissionEligibleRoute({
  children,
  allowedConsultantTypes,
}: CommissionEligibleRouteProps) {
  const { consultantType, commissionEligible } = useAuth();

  if (
    consultantType == null ||
    commissionEligible === false ||
    (allowedConsultantTypes && !allowedConsultantTypes.includes(consultantType))
  ) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
